"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _utils = require("../utils");
var _consts = require("../utils/consts");
var getAttributeValue = function getAttributeValue(type, value) {
  if (type !== 'date' || !value || !value.includes(_consts.ATTRIBUTE_TIME_SUFFIX)) return value;
  // To fix EUI, we'll start to use a specific time format for all attribute values (1 second offset)
  // >> From data Source
  //    - will always use user picked date + ATTRIBUTE_TIME_SUFFIX as the UTC time.
  //      E.g. user picked 2022-04-14, we'll save 2022-04-14T${ATTRIBUTE_TIME_SUFFIX}.000Z as the attribute value
  // >> For value display
  //    - First use the UTC date as user local time and parse it to UTC, to ensure all date component could display the value as normal.
  // >> For legacy value before the change
  //    - Don't touch any legacy date without the specific ATTRIBUTE_TIME_SUFFIX, to ensure legacy data work as previous.
  //    - As it's hard to migrate all legacy values.
  //    - Cannot simply adopt above logic as we need ensure the search filter can work as previous.
  var index = value.indexOf(_consts.ATTRIBUTE_TIME_SUFFIX) + _consts.ATTRIBUTE_TIME_SUFFIX.length;
  return _utils.DateUtil.dateToISOString(value.slice(0, index));
};

/**
 * [Model] CustomAttribute Parser
 */
var CustomAttribute = exports["default"] = /*#__PURE__*/function () {
  function CustomAttribute() {
    (0, _classCallCheck2["default"])(this, CustomAttribute);
  }
  return (0, _createClass2["default"])(CustomAttribute, null, [{
    key: "parseV1",
    value:
    /**
     * Parse docs snake case data. Usually from Rails API.
     *
     * @param data - the object to parse
     */
    function parseV1(data) {
      var rowData = data || {};
      var ca = new CustomAttribute();
      ca.id = rowData.id;
      ca.type = rowData.attribute_type;
      ca.name = rowData.name || '';
      ca.value = getAttributeValue(rowData.attribute_type, rowData.value);
      ca.identifier = rowData.identifier;
      ca.visible = rowData.visible;
      return ca;
    }

    /**
     * Parse camel case data
     *
     * @param data - the object to parse
     */
  }, {
    key: "parseV2",
    value: function parseV2(data) {
      var _rowData$properties;
      var rowData = data || {};
      var entity = new CustomAttribute();
      entity.id = rowData.id;
      entity.type = rowData.type;
      entity.name = rowData.name || '';
      entity.value = getAttributeValue(rowData.type, rowData.value);
      entity.identifiedCode = (_rowData$properties = rowData.properties) === null || _rowData$properties === void 0 ? void 0 : _rowData$properties.identifiedCode;
      entity.isSystem = !!rowData.isSystem;
      entity.systemName = rowData.systemName;
      return entity;
    }

    /**
     * Parse camel case data
     *
     * @param data - the object to parse
     */
  }, {
    key: "parseV3",
    value: function parseV3(data) {
      var _rowData$properties2, _rowData$properties3, _rowData$properties4, _rowData$properties5, _rowData$properties6;
      var rowData = data || {};
      var entity = new CustomAttribute();
      entity.id = rowData.id;
      entity.type = rowData.type;
      entity.name = rowData.name || '';
      entity.description = rowData.description;
      entity.value = getAttributeValue(rowData.type, rowData.value);
      entity.options = rowData.options;
      entity.createdBy = rowData.createdBy && rowData.createdBy.id;
      entity.createdByName = rowData.createdBy && rowData.createdBy.name;
      entity.updatedBy = rowData.updatedBy && rowData.updatedBy.id;
      entity.updatedByName = rowData.updatedBy && rowData.updatedBy.name;
      entity.attachedBy = rowData.attachedBy;
      entity.updatedAt = rowData.updatedAt;
      entity.isSystem = !!rowData.isSystem; // Added when parse search response from CP
      entity.hasConstraint = rowData.hasConstraint;
      entity.localId = ((_rowData$properties2 = rowData.properties) === null || _rowData$properties2 === void 0 ? void 0 : _rowData$properties2.localId) || rowData.localId;
      entity.isoCode = (_rowData$properties3 = rowData.properties) === null || _rowData$properties3 === void 0 ? void 0 : _rowData$properties3.isoCode;
      entity.identifiedCode = (_rowData$properties4 = rowData.properties) === null || _rowData$properties4 === void 0 ? void 0 : _rowData$properties4.identifiedCode;
      entity.uploadRequired = !!((_rowData$properties5 = rowData.properties) !== null && _rowData$properties5 !== void 0 && _rowData$properties5.uploadRequired);
      entity.reservedActions = ((_rowData$properties6 = rowData.properties) === null || _rowData$properties6 === void 0 ? void 0 : _rowData$properties6.reservedActions) || [];

      // Naming standard related
      entity.namingStandardIds = rowData.namingStandardIds || [];
      entity.usedByNS = entity.namingStandardIds.length > 0;

      // Translate some common attribute name if necessary
      entity.name = _utils.AttributeUtil.getLocalizedName(entity);
      entity.rawName = rowData.name;
      return entity;
    }
  }]);
}();